<div class="participant-table-wrapper">
	<div class="participant-search mb-2" *ngIf="!isCheckAll">
		<input
			type="text"
			class="form-control"
			placeholder="Search student..."
			[(ngModel)]="searchTerm"
			(input)="onSearchInputChange()"
			(keydown.enter)="onSearch()"
		/>
		<button type="button" class="btn btn-primary btn-sm" (click)="onSearch()">
			Search
		</button>
	</div>

	<div class="table-responsive table-list-wrapper table-fixed" *ngIf="participants && participants.length > 0 && !isCheckAll">
		<table class="table table-list">
			<thead style="font-size: 12px">
				<tr>
					<th *ngIf="canSelect">
						<!-- <app-input-checkbox
							[name]="'is_block_all_participant'"
							[isChecked]="isCheckAllCurrentPage()"
							(onChecked)="onToggleCheckAll()">
						</app-input-checkbox> -->
					</th>
					<th>Student Id</th>
					<th>Class Name</th>
					<th>Student Name</th>
				</tr>
			</thead>
			<tbody style="font-size: 12px">
				<tr *ngFor="let item of participants; let i = index" class="col-md-12">
					<td *ngIf="canSelect" class="col-md-1">
						<app-input-checkbox
							[name]="'participant-check-' + i + '-' + item.student_id"
							[isChecked]="isChecked(item.student_id)"
							(onChecked)="onToggleRow(item)">
						</app-input-checkbox>
					</td>
					<td class="text-center col-md-2">{{ item.nis }}</td>
					<td class="text-center col-md-2">{{ item.class_name }}</td>
					<td class="text-center col-md-5">{{ item.student_name }}</td>
				</tr>
			</tbody>
		</table>
	</div>

	<div>
		<app-status-no-data [show]="!loading && (!participants || participants.length === 0)"></app-status-no-data>
		<app-status-loading [show]="loading"></app-status-loading>
	</div>

	<div>
		<app-input-checkbox
			[name]="'is_check_all_participant'"
			[label]="'Check All Student'"
			[isChecked]="isCheckAll"
			(onChecked)="onToggleCheckAllAvailableStudents()">
		</app-input-checkbox>
	</div>

	<div>
		<mat-paginator
			class="participant-paginator"
			[pageSize]="query.page_size"
			[pageIndex]="query.page - 1"
			[length]="total"
			[pageSizeOptions]="[10, 15, 25, 50]"
			[showFirstLastButtons]="true"
			(page)="onPageChanged($event)">
		</mat-paginator>
	</div>
</div>
